import React from 'react'
import styled from 'styled-components'
import CategoryCard from './category'
import MobileMenu from './mobile-menu'

type Params = {
  category: any[]
  tags: any[]
}

const RightMenu = (params: Params) => {
  return (
    <BannerBox>
      <div className="right-content">
        {params.category.length > 0 && <CategoryCard category={params.category} />}
        {params.tags.length > 0 && <MobileMenu tags={params.tags} />}
      </div>
    </BannerBox>
  )
}

export default RightMenu

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    .right-content {
      display: none;
    }
  }
  @media only screen and (min-width: 1000px) {
    .right-content {
      width: 200px;
      height: 100vh;
      border-radius: 8px;
    }
  }
`
